import { useRef, useState } from "react";
import { formatDataCompare, formatDateTime, formatDecimal, getLocalStorage, setLocalStorage } from "../../../commons/utils";
import { ConsultaPadrao } from "../../../components/ConsultaPadrao";
import { model_movimento_single, model_tipo_movimento } from "../../../models";
import { Gallery, GalleryHandler } from "../../Gallery";
import { Download, Paperclip, Printer } from "lucide-react";
import { useAuth } from "../../../contexts/AuthProvider/useAuth";
import { deleteMovimentoArquivo, getFilesMovimento, uploadMovimentoArquivo } from "./utils";
import PdfGenerator, { PdfGeneratorHandler } from "../../../components/PdfGenerator";

export const EstoquesMovimentos = () => {
    const auth = useAuth();

    const refdatatable = useRef<any>(null);
    const tipomovref = useRef<any>(null);
    const iemissaoref = useRef<any>(null);
    const femissaoref = useRef<any>(null);
    const refgallery = useRef<GalleryHandler>(null);
    const refMovimentoPdf = useRef<PdfGeneratorHandler>(null);

    const [showing, setShowing] = useState(false);

    const columns = [
        { field: 'movimentodescricao', header: 'Identificador', style: { whiteSpace: 'pre-wrap' } },
        { field: 'descricao', header: '', notSortable: true, style: { whiteSpace: 'pre-wrap' } },
        { field: 'movemissao', header: 'Emissão', body: (e: any) => formatDateTime(e.movemissao), dataType: 'date', style: { maxWidth: '100px' } },
        { field: 'volume', header: 'Volume (KG)', dataType: 'numeric', body: (e: any) => formatDecimal(e.volume), style: { maxWidth: '100px' } },
        { field: 'usunome', header: 'Usuário', style: { whiteSpace: 'pre-wrap' } },
        { field: 'tipmovstdescricao', header: 'Situação' },
        { field: 'functions', style: { width: '1rem' } }
    ];

    function getFunctions(row: any) {
        return [{
            click: async () => {
                const slots = await getFilesMovimento(auth, row.tipmovcontador, row.movid);

                refgallery.current?.openModal(
                    slots,
                    row.movimentodescricao,
                    row.movid,
                    false
                );
            },
            icon: <Paperclip size={20} />,
            disabled: row.qtdearquivos === '0'
        },
        {
            click: () => refMovimentoPdf.current?.generatePDF('download', { tipmovcontador: row.tipmovcontador, movid: row.movid }),
            icon: <Download size={20} />
        },
        {
            click: () => refMovimentoPdf.current?.generatePDF('view', { tipmovcontador: row.tipmovcontador, movid: row.movid }),
            icon: <Printer size={20} />
        },
        ]
    }

    function filterData(data: any, iEmissao: any, fEmissao: any, tipMov: any) {
        let _data: any = [];

        _data = data;

        if (iEmissao)
            _data = _data.filter((item: any) => formatDataCompare(item.movemissao) >= iEmissao);

        if (fEmissao)
            _data = _data.filter((item: any) => formatDataCompare(item.movemissao) <= fEmissao);

        if (tipMov && (tipMov.length > 0)) {
            const _tipMov = new Set(tipMov.map((item: any) => item.value));
            _data = _data.filter((item: any) => _tipMov.has(item.tipmovcontador));
        }

        setLocalStorage('i_emissao_tipmov_mov', iEmissao ?? null);
        setLocalStorage('f_emissao_tipmov_mov', fEmissao ?? null);

        refdatatable.current.setCustomData(_data);
    }

    function afterRefresDataTable(data: any) {
        var iEmissao;
        var fEmissao;

        if (!showing) {
            iEmissao = getLocalStorage('i_emissao_tipmov_mov');
            fEmissao = getLocalStorage('f_emissao_tipmov_mov');

            filterData(data, iEmissao, fEmissao, []);

            setShowing(true);
        } else
            filterData(data, iemissaoref.current.getValue(), femissaoref.current.getValue(), tipomovref.current.getValue())
    }

    async function changeEmissaoInicial(value: any, data: any) {
        filterData(data, value, femissaoref.current.getValue(), tipomovref.current.getValue())
    }

    async function changeEmissaoFinal(value: any, data: any) {
        filterData(data, iemissaoref.current.getValue(), value, tipomovref.current.getValue())
    }

    async function changeTipoMovimento(selecteds: any, data: any) {
        filterData(data, iemissaoref.current.getValue(), femissaoref.current.getValue(), selecteds)
    }

    const filters = [
        {
            ref: iemissaoref, md: 2, id: 'i_emissao_tipmov_mov', label: 'Emissão Inicial', type: 'date',
            onChange: changeEmissaoInicial, defaultValue: getLocalStorage('i_emissao_tipmov_mov')
        },
        {
            ref: femissaoref, md: 2, id: 'f_emissao_tipmov_mov', label: 'Emissão Final', type: 'date',
            onChange: changeEmissaoFinal, defaultValue: getLocalStorage('f_emissao_tipmov_mov')
        },
        {
            ref: tipomovref, md: 8, id: 'tipmov', label: 'Tipo Movimento', type: 'select',
            onChange: changeTipoMovimento, model: model_tipo_movimento, isMulti: true
        }
    ]

    return (
        <>
            <ConsultaPadrao
                ref={refdatatable}
                model={model_movimento_single}
                columns={columns}
                inputfilters={filters}
                onAfterRefresh={afterRefresDataTable}
                functions={getFunctions}
            />
            <PdfGenerator ref={refMovimentoPdf} api="/v1/movimentopdfgenerate" />
            <Gallery ref={refgallery} onUploadFile={(movid, file) => uploadMovimentoArquivo(auth, movid, file)} onRemoveFile={(movid, file) => deleteMovimentoArquivo(auth, movid, file)} />
        </>
    )
}